import config from '../config/index'
import {
  IPlan,
  IPlanFormData,
  PaginatedPlan,
  PaginatedPlanFilterParams,
} from '../pages/plans-container/share-type'
import { authRequest } from '../request'

const { mainApi } = config

export const getPaginatedPlans = (data: PaginatedPlanFilterParams) =>
  authRequest.get<MISSING_TYPE, PaginatedPlan>(`${mainApi}/plans`, {
    params: data,
  })

export const getPlanDetail = (planId: number) =>
  authRequest.get<MISSING_TYPE, IPlan>(`${mainApi}/plans/${planId}`)

export const createPlan = (data: IPlanFormData) =>
  authRequest.post<MISSING_TYPE, IPlan>(`${mainApi}/plans`, data)

export const editPlan = (planId: number, data: IPlanFormData) =>
  authRequest.put<MISSING_TYPE, IPlan>(`${mainApi}/plans/${planId}`, data)

export const deactivatePlan = (planId: number) =>
  authRequest.delete<MISSING_TYPE, void>(`${mainApi}/plans/${planId}`)
